"use client";

import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren, ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ReactQueryStreamedHydration } from "@tanstack/react-query-next-experimental";
import { lazy, useEffect, useState } from "react";
const queryClient = new QueryClient();
const ReactQueryDevtoolsProduction = lazy(() => import("@tanstack/react-query-devtools/production").then(mod => ({
  default: mod.ReactQueryDevtools
})));
export function ReactQueryProvider(t0) {
  const $ = _c(10);
  const {
    children
  } = t0;
  const [showDevtools, setShowDevtools] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      window.toggleDevtools = () => {
        setShowDevtools(_temp);
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== children) {
    t3 = <ReactQueryStreamedHydration>{children}</ReactQueryStreamedHydration>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ReactQueryDevtools initialIsOpen={true} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== showDevtools) {
    t5 = showDevtools ? <ReactQueryDevtoolsProduction /> : null;
    $[5] = showDevtools;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <QueryClientProvider client={queryClient}>{t3}{t4}{t5}</QueryClientProvider>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
function _temp(old) {
  return !old;
}